// extracted by mini-css-extract-plugin
export var campaignContainer = "t_r0 d_dW";
export var campaignContainerFull = "t_r1 d_dT";
export var wrapper = "t_r2 d_w";
export var leftWrapper = "t_r3 d_bz d_bN";
export var rightWrapper = "t_r4";
export var subtitle = "t_r5";
export var title = "t_r6";
export var text = "t_pc d_cs";
export var inlineWrapper = "t_r7 d_bC d_bG d_w";
export var btnsWrapper = "t_r8 t_r7 d_bC d_bG d_w d_bJ";
export var priceWrapper = "t_r9 t_r7 d_bC d_bG d_w d_ch d_bP";
export var priceHeading = "t_sb";
export var disclaimerWrapper = "t_sc d_cD";
export var mediaSlot = "t_sd";
export var listWrapper = "t_sf d_bC d_bP d_w";
export var btnWrapper = "t_d2";
export var imageWrapper = "t_rj d_fg d_Z";
export var SmallSmall = "t_sg y_sg y_sP y_s9";
export var SmallNormal = "t_sh y_sh y_sP y_tb";
export var SmallLarge = "t_sj y_sj y_sP y_s7";
export var textLeft = "t_dv";
export var textCenter = "t_dw";
export var textRight = "t_dx";
export var alignLeft = "t_rd";
export var alignCenter = "t_bP";
export var alignRight = "t_rf";